import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const ApprovalBanner: LoadableType<{}> = LoadableAfterPaint({
	name: 'ApprovalBannerLoadable',
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ApprovalBanner" */ '../src/BannerComponent/ApprovalBanner.tsx'
			)
		).ApprovalBanner,
});
